export const DETECTIONCLUSTER_LIST = 'DETECTIONCLUSTER_LIST';
export const DETECTIONCLUSTER_LIST_SUCCESS = 'DETECTIONCLUSTER_LIST_SUCCESS';
export const DETECTIONCLUSTER_LIST_ERROR = 'DETECTIONCLUSTER_LIST_ERROR';

export const DETECTIONCLUSTER_DETAILS = 'DETECTIONCLUSTER_DETAILS';
export const DETECTIONCLUSTER_DETAILS_SUCCESS = 'DETECTIONCLUSTER_DETAILS_SUCCESS';
export const DETECTIONCLUSTER_DETAILS_ERROR = 'DETECTIONCLUSTER_DETAILS_ERROR';

export const ADD_DETECTIONCLUSTER = 'ADD_DETECTIONCLUSTER';
export const ADD_DETECTIONCLUSTER_SUCCESS = 'ADD_DETECTIONCLUSTER_SUCCESS';
export const ADD_DETECTIONCLUSTER_ERROR = 'ADD_DETECTIONCLUSTER_ERROR';

export const UPDATE_DETECTIONCLUSTER = 'UPDATE_DETECTIONCLUSTER';
export const UPDATE_DETECTIONCLUSTER_SUCCESS = 'UPDATE_DETECTIONCLUSTER_SUCCESS';
export const UPDATE_DETECTIONCLUSTER_ERROR = 'UPDATE_DETECTIONCLUSTER_ERROR';

export const DELETE_DETECTIONCLUSTER = 'DELETE_DETECTIONCLUSTER';
export const DELETE_DETECTIONCLUSTER_SUCCESS = 'DELETE_DETECTIONCLUSTER_SUCCESS';
export const DELETE_DETECTIONCLUSTER_ERROR = 'DELETE_DETECTIONCLUSTER_ERROR';

export const DETECTIONALG_LIST = 'DETECTIONALG_LIST';
export const DETECTIONALG_LIST_SUCCESS = 'DETECTIONALG_LIST_SUCCESS';
export const DETECTIONALG_LIST_ERROR = 'DETECTIONALG_LIST_ERROR';